
import Graph from '../../Assets/Images/CaseStudy/ERP.png';
import heroBackground from '../../Assets/Images/Aboutus/3398605.jpg';
import teamMember1 from "../../Assets/Images/Employees/Sagar Shete.jpg";
import teamMember2 from "../../Assets/Images/Employees/Raksha Yeole.jpg";
import teamMember3 from "../../Assets/Images/Employees/Pratiksha Kote.jpg";
import teamMember4 from "../../Assets/Images/Employees/Siddhi Mhaske.jpg";
import teamMember5 from "../../Assets/Images/Employees/Pragati Lahote.jpg";
import teamMember6 from "../../Assets/Images/Employees/Dnyanda Kale.jpg";
import teamMember7 from "../../Assets/Images/Employees/Vaishnavi Koban.jpg";
import teamMember8 from "../../Assets/Images/Employees/Piyush Bahalkar.jpg";
import teamMember9 from "../../Assets/Images/Employees/Vaishnavi Kadu.jpg";
import teamMember11 from "../../Assets/Images/Employees/Gayatri Khalipe.jpg";
import teamMember12 from "../../Assets/Images/Employees/Sakshi Pote.jpg";
import teamMember13 from "../../Assets/Images/Employees/Rani Waghmare.jpg";
import teamMember14 from "../../Assets/Images/Employees/Vaibhavi Nighvekar.jpg";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import groupPhoto from '../../Assets/Images/Employees/Group Photo.jpg';
import "../../Assets/CSS/Home.scss";
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

import journeyBg from '../../Assets/Images/Aboutus/bg-3.jpg';
import bgImage from '../../Assets/Images/CaseStudy/honeyc.jpg';

import "../../Assets/CSS/Styles.scss";
import { Button } from 'react-bootstrap';


const AboutUs = () => {

  const teamMembers = [
    { name: "Sagar Shete", designation: "Managing Director", image: teamMember1 },
    { name: "Raksha Yeole", designation: "Full-Stack Developer", image: teamMember2 },
    { name: "Pratiksha Kote", designation: "Full-Stack Developer", image: teamMember3 },
    { name: "Pragati Lahote", designation: "Full-Stack Developer", image: teamMember5 },
    { name: "Siddhi Mhaske", designation: "Frontend Developer", image: teamMember4 },
    { name: "Dnyanda Kale", designation: "Frontend Developer", image: teamMember6 },
    { name: "Piyush Bahalkar", designation: "Backend Developer", image: teamMember8 },
    { name: "Vaishnavi Kadu", designation: "Backend Developer", image: teamMember9 },
    { name: "Vaishnavi Koban", designation: "UI-UX Designer", image: teamMember7 },
    { name: "Gayatri Khalipe", designation: "Software Tester", image: teamMember11 },
    { name: "Sakshi Pote", designation: "Software Tester", image: teamMember12 },
    { name: "Rani Waghmare", designation: "Software Tester", image: teamMember13 },
    { name: "Vaibhavi Nighvekar", designation: "HR", image: teamMember14 },

  ];
  const timelineData = [
    { year: '2018', title: 'Ideation Phase', text: 'Began conceptualizing an entrepreneurial venture.' },
    { year: '2022', title: 'Vision Finalization', text: 'Focused on EdTech innovation to reduce workload.' },
    { year: '2023', title: 'Company Formation', text: 'Company officially founded; remote team assembled.' },
    { year: '2024', title: 'Expansion', text: 'Scaled operations with HQ and 20+ team members.' },
    { year: '2025', title: 'Major Product Launch', text: 'Launched NEP-ready 3-module ERP solution.' },
  ];
  const containerRef = useRef(null);
  const [visibleIndex, setVisibleIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && visibleIndex < timelineData.length) {
          const interval = setInterval(() => {
            setVisibleIndex((prev) => {
              if (prev >= timelineData.length - 1) {
                clearInterval(interval);
                return prev;
              }
              return prev + 1;
            });
          }, 400);
        }
      },
      { threshold: 0.3 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [timelineData.length, visibleIndex]);

  const [journeyVisible, setJourneyVisible] = useState(false);
  const journeyRef = useRef(null);

  useEffect(() => {
    const element = journeyRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setJourneyVisible(true);
          observer.unobserve(entry.target); // animate only once
        }
      },
      { threshold: 0.2 }
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 4,
          dots: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Set initial value
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className="about-us-container">
      <div className="relative h-[650px] md:h-[488px] flex flex-col items-center justify-center text-center text-white overflow-hidden mt60 "
      >
        <div
          className="absolute inset-0 bg-cover bg-center animate-slowZoom"
          style={{ backgroundImage: `url(${heroBackground})` }}
        ></div>

        <div className="absolute inset-0 bg-black bg-opacity-70 z-10"></div>
        <div className="relative z-20 max-w-4xl mx-auto px-4 space-y-6 ">
          <h1 className="font-heading font-bold-500 text-white text-3xl sm:text-4xl md:text-5xl mt60 lg:text-5xl text-center mb-4 sm:mb-6">
            Empowering Education through<br />
            <span className="text-[#F59E0B] inline-block mt-2 sm:mt-4">Smart Technology</span>
          </h1>

          <p className="font-ui text-white text-base sm:text-lg leading-relaxed sm:leading-normal text-center max-w-2xl mx-auto">
            Cloud-based ERP for schools, colleges & educational trusts automating workflows, unlocking insights, and fueling better outcomes.
          </p>

          {/* Button */}
          <div className="flex justify-center">
            <Button
              as={Link}
              to="/contact"
              className="cta-btn bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center mt-2 gap-2 border-0"
            >
              Get In Touch
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Button>
          </div>

          {/* Statistics Section - Improved mobile spacing */}
          <div className="flex flex-wrap justify-center items-center gap-6 sm:gap-8 mt-8 sm:mt-10 pt-4 ">
            <div className="text-center min-w-[100px]">
              <p className="text-2xl sm:text-3xl font-bold font-ui font-heading">10+</p>
              <p className="text-xs sm:text-sm mt-1">Years Experience</p>
            </div>
            <div className="text-center min-w-[100px]">
              <p className="text-2xl sm:text-3xl font-bold font-ui font-heading">24+</p>
              <p className="text-xs sm:text-sm mt-1">Service Support</p>
            </div>
            <div className="text-center min-w-[100px]">
              <p className="text-2xl sm:text-3xl font-bold font-ui font-heading">99.9%</p>
              <p className="text-xs sm:text-sm mt-1">Uptime Guaranteed</p>
            </div>
          </div>
        </div>

      </div>


      {/* Who Are We Section */}
      <section className="py-12 px-4 md:px-8 lg:px-16 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="Headers font-heading font-ui">
            Who Are We
          </h2>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="lg:w-3/4 font-body font-ui font-bold-500 space-y-6 text-lg leading-relaxed ">
              <p>
                Welcome to <span className="font-body font-ui font-heading-bold">Global Solutions</span>, a leading provider of innovative and
                comprehensive Education ERP solutions.
              </p>
              <p>
                At <span className="font-body font-ui font-heading-bold">Global Solutions</span>, we believe that education is the cornerstone of
                progress, and we are committed to supporting educational institutions
                in their pursuit of excellence. Our team comprises dedicated
                professionals with a passion for technology and education. We have
                combined our expertise to develop a robust and user-friendly
                Education ERP system that caters to the specific needs of institutions.
              </p>
            </div>
            <div className="lg:w-2/5 flex justify-center items-center">
              <div className="relative w-full max-w-lg">
                <img
                  src={Graph}
                  alt="Growth Chart"
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OUR Journey section */}
      <section
        ref={journeyRef}
        className="py-16 px-4 md:px-8 lg:px-16 relative"
        style={{
          backgroundImage: `url(${journeyBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: isMobile ? 'scroll' : 'fixed',
          maskImage: !isMobile
            ? 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)'
            : 'none',
          WebkitMaskImage: !isMobile
            ? 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)'
            : 'none',
        }}
      >
        {/* Stronger overlay on mobile */}
        <div className={`absolute inset-0 ${isMobile ? 'bg-white/95' : 'bg-white/80'} z-0`}></div>

        <div
          className={`relative z-10 max-w-4xl mx-auto text-center transition-opacity duration-1000 ${journeyVisible ? 'animate-slideFromBottom' : 'opacity-0'
            }`}
        >
          <h2 className="text-3xl font-bold mb-4 font-heading">Our Journey</h2>
          <p className="text-gray-600 mb-10">
            From a startup to India's trusted EdTech partner
          </p>

          <div ref={containerRef} className="space-y-6 relative">
            {/* Timeline line - adjusted for mobile */}
            <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-indigo-500 via-purple-500 to-yellow-400 -translate-x-1/2 z-0" />

            {timelineData.map((item, index) => (
              <div
                key={item.year}
                className={`shadow-xl border border-[#F59E0B] overflow-hidden relative max-w-md mx-auto bg-white rounded-lg px-6 pt-8 pb-4 transition-all duration-700 ease-out ${index > visibleIndex ? 'opacity-0 translate-y-6' : 'opacity-100 translate-y-0'
                  }`}
              >
                <div className="absolute left-1/2 top-4 transform -translate-x-1/2 z-10">
                  <div className="h-4 w-4 bg-orange-400 rounded-full border-2 border-white"></div>
                </div>

                <h3 className="text-lg font-bold text-gray-900">{item.year}</h3>
                <p className="text-indigo-700 font-semibold mb-1">{item.title}</p>
                <p className="text-sm text-gray-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Mission, Vision & Values Section */}
      <section className="py-7 px-4 md:px-8 lg:px-16 bg-white">
        <div className="max-w-7xl mx-auto text-center ">
          <h2 className="Headers font-heading font-ui">Our Mission, Vision & Values</h2>
          <p className="text-gray-600 font-ui mb-12">Guided by our core principles, we're committed to transforming education <br />Through technology</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: "Mission",
                desc:
                  "To innovate and evolve ERP solutions that empower educational institutions to meet emerging needs and thrive in a digital world.",
                icon: (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 10v11h18V10M3 10l9-6 9 6M3 10h18"
                  />
                ),
              },
              {
                title: "Vision",
                desc:
                  "To redefine the education landscape by delivering intelligent ERP solutions that enhance efficiency, engagement and growth.",
                icon: (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                ),
              },
              {
                title: "Innovation",
                desc:
                  "Continuously evolving our solutions with cutting-edge technology to meet the changing needs of modern education.",
                icon: (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                ),
              },
              {
                title: "Reliability",
                desc:
                  "Providing dependable, secure, and scalable solutions that institutions can trust for their critical operations.",
                icon: (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m5.618-4.279A11.952 11.952 0 0112 21c-2.915 0-5.669-.734-8.052-2.031a.996.996 0 01-.453-1.077L4.414 12H4a8 8 0 01-8-8V4"
                  />
                ),
              },
            ].map(({ title, desc, icon }, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-500 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                {/* Floating Icon */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <svg
                      className="h-7 w-7 text-amber-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {icon}
                    </svg>
                  </div>
                </div>

                {/* Content */}
                <div className="mt-5">
                  <h3 className="text-[20px] font-bold text-[#111827] mb-2">{title}</h3>
                  <p className="text-[15px] text-[#374151] font-ui">{desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Meet Our Team Section */}
      <section className="py-16 px-4 md:px-8 lg:px-16 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold Headers font-heading mb-4">Meet Our Team</h2>

          <p className="text-gray-600 font-ui mb-12">
            Passionate educators and technologists working together to redefine education
          </p>

          {/* Team Member Carousel */}
          <div className="mb-16 px-2">
            <Slider {...settings}>
              {teamMembers.map((member) => (
                <div key={member.id} className="px-2 focus:outline-none">
                  <div className="bg-white rounded-lg shadow-md overflow-hidden h-[380px] border-2 border-[#F59E0B] mx-auto max-w-[280px]">
                    <div className="h-[250px] w-full overflow-hidden">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-105"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-semibold text-lg text-gray-800 mb-3">
                        {member.name}
                      </h3>
                      <p className="text-gray-600 text-sm">
                        {member.designation}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Group Photo Section */}
          <div className="max-w-5xl mx-auto px-2">
            <div className="relative rounded-lg overflow-hidden border-2 border-[#F59E0B]">
              <img
                src={groupPhoto}
                alt="Our Staff"
                className="w-full h-full object-cover sm:object-contain object-center "
              />
            </div>
          </div>

        </div>
      </section>

      {/* Our Culture Section */}
      <section className="py-5 px-4 md:px-8 lg:px-16 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="bg-[#007BFF] rounded-lg shadow-md p-8 text-center text-white min-h-[250px]">
            <h2 className="text-3xl sm:text-xxl font-heading-bold mt-4 mb-4">Our Culture</h2>
            <p className="text-base sm:text-lg font-ui leading-relaxed">
              We treat every partner as family. Our collaborative approach<br />
              ensures that your success becomes our success, building lasting<br />
              relationships that go beyond technology.
            </p>
          </div>
        </div>
      </section>

      {/* Why Institutions Choose Us Section */}
      <section
        id="why-choose-us"
        className="relative py-16 overflow-hidden"
        style={{
          // Background styles
          backgroundImage: !isMobile ? `url(${bgImage})` : 'none',
          backgroundColor: isMobile ? '#f8f8f8' : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          // Masking - only apply on desktop
          maskImage: !isMobile
            ? 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)'
            : 'none',
          WebkitMaskImage: !isMobile
            ? 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)'
            : 'none',
        }}
      >
        {/* Overlay - stronger on mobile for better readability */}
        <div className={`absolute inset-0 ${isMobile ? 'bg-white bg-opacity-95' : 'bg-white bg-opacity-80'} z-0`}></div>

        <div className="max-w-7xl relative z-10 mx-auto px-4 text-center">
          <h2 className="Headers font-heading font-ui">Why Institutions Choose Us</h2>
          <p className="text-gray-600 font-ui mb-10">
            We're more than just a technology provider—we're your partner in educational excellence
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: '50+ Institutions Powered',
                desc: 'Trusted by schools, colleges, and educational trusts nationwide',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm0-4V7a1 1 0 00-1-1H9a1 1 0 00-1 1v3m4 0h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v3zm-4 0v3a1 1 0 001 1h2a1 1 0 001-1V9M5 5a2 2 0 012-2h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5z" />
                ),
              },
              {
                title: '10+ Years EdTech Experience',
                desc: 'Deep understanding of educational workflows and challenges',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                ),
              },
              {
                title: 'Multicampus Management',
                desc: 'Centralized control across multiple locations and branches',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m0 0l-7 7-7-7m7 7v10a1 1 0 01-1 1h-3" />
                ),
              },
              {
                title: 'Real-Time Analytics',
                desc: 'Data-driven insights for better decision making',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 12l3-3 3 3 4-4M18 10V6M6 18h.01M18 18h.01M6 12h.01M18 12h.01M12 6h.01M12 18h.01M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z" />
                ),
              },
              {
                title: '99% System Uptime',
                desc: 'Reliable, secure, and always available when you need it',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.01 12.01 0 002 12c0 2.514.809 4.815 2.182 6.79M12 21h9M3 10h18" />
                ),
              },
              {
                title: 'Continuous Support Services',
                desc: 'Round-the-clock assistance from our expert support team',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0zm-6 2H6M9 12v3M15 12v3m-6-3h3a3 3 0 003-3V6a3 3 0 00-3-3h-3a3 3 0 00-3 3v3a3 3 0 003 3z" />
                ),
              },
            ].map(({ title, desc, icon }, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-500 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                {/* Floating Icon */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <svg
                      className="h-7 w-7 text-amber-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {icon}
                    </svg>
                  </div>
                </div>

                {/* Content */}
                <div className="mt-4">
                  <h3 className="text-[20px] font-bold text-[#111827] mb-2">{title}</h3>
                  <p className="text-[15px] text-[#374151] font-ui">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ready to Transform Your Institution? Section */}

      <div className="bg-blue-900 py-16 text-white text-center px-4">
        <div className="container mx-auto">
          <h2 className="font-heading font-bold mb-4 text-2xl md:text-[35px]">
            {/* Use responsive text sizes: text-2xl for mobile, md:text-[35px] for medium screens and up */}
            Let's Build a Smarter Campus Together
          </h2>
          <p className="text-sm md:text-[18px] text-center max-w-2xl mx-auto font-ui mb-8">
            {/* Use responsive text sizes: text-sm for mobile, md:text-[18px] for medium screens and up */}
            Ready to revolutionize your educational institution? Get in touch with our experts and see how GlobSolutions can transform your operations.
          </p>
          <div className="bg-blue-800/50 p-6 md:p-11 rounded-lg shadow-lg max-w-full md:max-w-[800px] mx-auto">
            {/* Removed fixed width w-[800px] and used max-w-full for flexibility. Added padding for both mobile and desktop. */}
            <h3 className="font-semibold text-lg md:text-[20px] font-ui mb-4">
              {/* Use responsive text sizes */}
              Get Your Free Consultation
            </h3>
            <p className="text-sm md:text-base mb-6">
              {/* Use responsive text sizes */}
              See GlobSolutions ERP in action with a personalized demo tailored to your institution's needs.
            </p>
            <Link to="/freedemo">
              <button className="bg-[#F59E0B] hover:bg-[#f3b541] px-6 py-3 rounded-lg demo-button font-bold text-sm md:text-[17px] font-ui items-center gap-2">
                {/* Use responsive text sizes for the button as well */}
                Book Demo Call
              </button>
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AboutUs;

